import { render, staticRenderFns } from "./JobStage.vue?vue&type=template&id=24a5fd14&"
import script from "./JobStage.vue?vue&type=script&lang=ts&"
export * from "./JobStage.vue?vue&type=script&lang=ts&"
import style0 from "./JobStage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
installComponents(component, {VChip})
